import type { AppConfig } from '../types'

/** Top bar. The logo/brand is a "home" control that returns to the first step (§7.1). */
export function Header({ config, onHome }: { config: AppConfig; onHome?: () => void }) {
  const { company } = config
  const logoOk = company.logo && !company.logo.includes('example.com')
  const inner = logoOk ? (
    <img className="logo" src={company.logo} alt={company.name} />
  ) : (
    <span className="brand-name">{company.name}</span>
  )

  return (
    <header className="app-header">
      {onHome ? (
        <button type="button" className="home-btn" onClick={onHome} aria-label={`${company.name} — start over`}>
          {inner}
        </button>
      ) : (
        inner
      )}
    </header>
  )
}
